import i18n from '@/utils/i18n';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { Typography } from '@usepepper/ui/atoms/typography';
import { View } from 'react-native';

interface Props {
  outstandingBalance?: string;
  partialPaymentAmount?: string | null;
  totalPrice?: string;
  unitCount?: number;
}

export const OrderDetailPrices: React.FC<Props> = ({
  outstandingBalance,
  partialPaymentAmount,
  totalPrice,
  unitCount,
}) => {
  const [styles, theme] = useStyles();
  return (
    <View style={styles.base} testID="order-detail-prices">
      {unitCount ? (
        <View style={styles.column}>
          <Typography variant="paragraph-md">{i18n.t('units')}</Typography>
          <Typography variant="heading-md">{unitCount}</Typography>
        </View>
      ) : null}
      {totalPrice ? (
        <View style={styles.column}>
          <Typography variant="paragraph-md">{i18n.t('total')}</Typography>
          <Typography variant="heading-md">{totalPrice}</Typography>
        </View>
      ) : null}
      {outstandingBalance ? (
        <View style={styles.column}>
          <Typography variant="paragraph-md">
            {i18n.t('outstanding_balance')}
          </Typography>
          <Typography variant="heading-md">{outstandingBalance}</Typography>
          {partialPaymentAmount ? (
            <Typography
              color={theme.sk.color.text.tertiary}
              variant="paragraph-md"
            >
              {i18n.t('partial_payment.summary', {
                amount: partialPaymentAmount,
              })}
            </Typography>
          ) : null}
        </View>
      ) : null}
      {!outstandingBalance && !totalPrice ? (
        <View style={styles.column}>
          <Typography
            color={theme.sk.color.text.tertiary}
            variant="paragraph-md"
          >
            {i18n.t('final_price_pending')}
          </Typography>
        </View>
      ) : null}
    </View>
  );
};

const useStyles = createStyles(() => ({
  base: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginVertical: 8,
  },
  column: {
    alignItems: 'flex-end',
    marginLeft: 48,
  },
}));
